import { render, staticRenderFns } from "./ModalAgendamento.vue?vue&type=template&id=5d64828e"
import script from "./ModalAgendamento.vue?vue&type=script&lang=js"
export * from "./ModalAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports